import { environment } from '../../environment';

/**
 * Types
 */
interface SystemErrors {
  400: string;
  401: string;
  403: string;
  404: string;
  500: string;
}

interface ServerConfig {
  host: string;
  path: string;
}

interface EnvConfig {
  env: string | undefined;
}

interface OktaOIDCConfig {
  clientId: string;
  baseUrl: string;
  issuerPath: string;
  issuer: string;
  loginUrl: string;
  redirectUri: string;
  scope: string[];
  responseType: ('id_token' | 'token')[];
  loginPath: string;
  logoutPath: string;
  autoRefresh: number;
}

interface LoginConfig {
  entry: string;
  redirectAfterLogin: string;
  redirectAfterLogout: string;
}

interface DatadogConfig {
  clientToken: string;
  applicationId: string;
  forwardErrorsToLogs: boolean;
  datacenter: string;
  samplerate: number;
}

interface LogConfig {
  level: 'info' | 'warn' | 'error' | 'debug';
  handler: string;
}

export interface AppConfig {
  baseUrlApp: string;
  lang: string;
  systemErrors: SystemErrors;
  server: ServerConfig;
  env: EnvConfig;
  oktaOIDC: OktaOIDCConfig;
  login: LoginConfig;
  datadogConfig: DatadogConfig;
  log: LogConfig;
}

/**
 * Runtime values
 */
const {
  oktaOIDC: { clientId, issuer, issuerPath, baseUrl },
  datadogConfig: { applicationId, clientToken }
} = environment();

/**
 * Config
 */
export const initialConfig: AppConfig = {
  baseUrlApp: '',
  lang: 'en',

  systemErrors: {
    400: 'bad request local',
    401: 'UnAuthorized Access',
    403: '403 Error',
    404: 'Page not found ------ test',
    500: 'Internal Server error'
  },

  server: {
    host: window.location.origin,
    path: ''
  },

  env: {
    env: import.meta.env.VITE_env
  },

  oktaOIDC: {
    clientId,
    baseUrl,
    issuerPath,
    issuer,
    loginUrl: baseUrl,
    redirectUri: '/login/implicit/callback',
    scope: ['openid', 'email', 'profile'],
    responseType: ['id_token', 'token'],
    loginPath: '/login',
    logoutPath: '/logout',
    autoRefresh: 1500
  },

  login: {
    entry: '/login',
    redirectAfterLogin: '/food/onboarding/secure',
    redirectAfterLogout: '/login'
  },

  datadogConfig: {
    clientToken,
    applicationId,
    forwardErrorsToLogs: true,
    datacenter: 'us',
    samplerate: 100
  },

  log: {
    level: 'info',
    handler: 'http'
  }
};

/**
 * Accessor
 */
const getAppConfig = (): AppConfig => initialConfig;

export default getAppConfig;